// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Formik, Form, Field } from "formik";
//import axios from "axios";
import TextField from "@material-ui/core/TextField";
import * as Yup from "yup";
import { Input } from "../../../../../../_metronic/_partials/controls";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";

// Validation schema
const SchSynopsysEditSchema = Yup.object().shape({
  submissionDate: Yup.date().required("Date is required"),
});

//const PageUrl = `${process.env.REACT_APP_API_URL}/api/scholar`;

export function SchSynopsysEditForm({ schSynopsys, btnRef, saveSchSynopsys }) {
  // const [menuForDropdown, setMenuForDropdown] = useState([]);

  // useEffect(() => {
  //   const getInnerPagesWithAxios = async () => {
  //     const response = await axios.get(PageUrl);
  //     setMenuForDropdown(response.data);
  //   };
  //   getInnerPagesWithAxios();
  // }, [setMenuForDropdown]);
  
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={schSynopsys}
        validationSchema={SchSynopsysEditSchema}
        onSubmit={(values) => {
          try {
            values.scholarId = parseInt(values.scholarId);
          } catch {}
          saveSchSynopsys(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <Form className="form form-label-right">
            <div className="form-group">
            Scholar Id:  {schSynopsys.scholarId}
                {/* <Field
                  name="scholarId"
                  component={Select}
                  placeholder="Scholar Name"
                  label="Scholar Name"
                  children={
                    menuForDropdown ? (
                      <>
                        <option value="0">None</option>
                        {menuForDropdown
                          .filter((menu) => menu.isActive)
                          .map((menu, index) => {
                            return (
                              <option key={index} value={menu.scholarId}>
                                {menu.scholarName}
                              </option>
                            );
                          })}
                      </>
                    ) : (
                      <option value="0">None</option>
                    )
                  }
                /> */}
              </div>
              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">Synopsys Submitted: </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Synopsys Submitted"
                    name="synopsysSubmitted"
                    value={schSynopsys.synopsysSubmitted}
                    onChange={(e) => {
                      setFieldValue(
                        "synopsysSubmitted",
                        JSON.parse(e.target.value)
                      );
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio
                          color="primary"
                          checked={values.synopsysSubmitted}
                        />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          color="primary"
                          checked={!values.synopsysSubmitted}
                        />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Submission Date"
                  type="date"
                  name="submissionDate"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("submissionDate", e.target.value);
                  }}
                />
              </div>

              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">Soft Copy: </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Soft Copy"
                    name="softCopy"
                    value={schSynopsys.softCopy}
                    onChange={(e) => {
                      setFieldValue("softCopy", JSON.parse(e.target.value));
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio color="primary" checked={values.softCopy} />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio color="primary" checked={!values.softCopy} />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Soft Copy Submission Date"
                  type="date"
                  name="softCopySubmissionDate"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("softCopySubmissionDate", e.target.value);
                  }}
                />
              </div>

              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">Hard Copy: </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Hard Copy"
                    name="hardCopy"
                    value={schSynopsys.hardCopy}
                    onChange={(e) => {
                      setFieldValue("hardCopy", JSON.parse(e.target.value));
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio color="primary" checked={values.hardCopy} />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio color="primary" checked={!values.hardCopy} />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Hard Copy Submission Date"
                  type="date"
                  name="hardCopySubmissionDate"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("hardCopySubmissionDate", e.target.value);
                  }}
                />
              </div>

              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">Drc Held: </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Drc Held"
                    name="drcHeld"
                    value={schSynopsys.drcHeld}
                    onChange={(e) => {
                      setFieldValue("drcHeld", JSON.parse(e.target.value));
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio color="primary" checked={values.drcHeld} />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio color="primary" checked={!values.drcHeld} />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Date Of Drc"
                  type="date"
                  name="dateOfDrc"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("dateOfDrc", e.target.value);
                  }}
                />
              </div>

              <div className="form-group">
                <Field
                  name="drcRemark"
                  component={Input}
                  placeholder="Drc Remark"
                  label="Drc Remark"
                />
              </div>

              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">Shodh Gangotri: </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Shodh Gangotri"
                    name="shodhGangotri"
                    value={schSynopsys.shodhGangotri}
                    onChange={(e) => {
                      setFieldValue(
                        "shodhGangotri",
                        JSON.parse(e.target.value)
                      );
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio color="primary" checked={values.shodhGangotri} />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          color="primary"
                          checked={!values.shodhGangotri}
                        />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <Field
                  name="shodhGangotriLink"
                  component={Input}
                  placeholder="Shodh Gangotri Link"
                  label="Shodh Gangotri Link"
                />
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Date Uploaded"
                  type="date"
                  name="dateUploaded"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("dateUploaded", e.target.value);
                  }}
                />
              </div>

              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">
                    Is Drc Letter Issued:{" "}
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Is Drc Letter Issued"
                    name="isDrcLetterIssued"
                    value={schSynopsys.isDrcLetterIssued}
                    onChange={(e) => {
                      setFieldValue(
                        "isDrcLetterIssued",
                        JSON.parse(e.target.value)
                      );
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio
                          color="primary"
                          checked={values.isDrcLetterIssued}
                        />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          color="primary"
                          checked={!values.isDrcLetterIssued}
                        />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">
                    Drc Presentation Held:{" "}
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Drc Presentation Held"
                    name="drcPresentationHeld"
                    value={schSynopsys.drcPresentationHeld}
                    onChange={(e) => {
                      setFieldValue(
                        "drcPresentationHeld",
                        JSON.parse(e.target.value)
                      );
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio
                          color="primary"
                          checked={values.drcPresentationHeld}
                        />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          color="primary"
                          checked={!values.drcPresentationHeld}
                        />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Date Of Drc Presentation"
                  type="date"
                  name="dateOfDrcPresentation"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("dateOfDrcPresentation", e.target.value);
                  }}
                />
              </div>

              <div className="form-group">
                <FormControl component="fieldset">
                  <FormLabel component="legend">Is Lab Applicable: </FormLabel>
                  <RadioGroup
                    row
                    aria-label="Is Lab Applicable"
                    name="isLabApplicable"
                    value={schSynopsys.isLabApplicable}
                    onChange={(e) => {
                      setFieldValue(
                        "isLabApplicable",
                        JSON.parse(e.target.value)
                      );
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio
                          color="primary"
                          checked={values.isLabApplicable}
                        />
                      }
                      label="Yes"
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          color="primary"
                          checked={!values.isLabApplicable}
                        />
                      }
                      label="No"
                      labelPlacement="start"
                    />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className="form-group">
                <Field
                  name="labName"
                  component={Input}
                  placeholder="Lab Name"
                  label="Lab Name"
                />
              </div>

              <div className="form-group">
                <Field
                  name="labCity"
                  component={Input}
                  placeholder="Lab City"
                  label="Lab City"
                />
              </div>

              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
